import { setSetting } from 'local/lib/settings';
import agent from 'local/test/agent';

export default function onConfiguration(m, configuration) {
	const update = { configuration };

	if (configuration.hashkey && !m.data.hashkey) {
		update.hashkey = configuration.hashkey;
		setSetting('hash_key', configuration.hashkey);

		agent.send({
			method: 'setConfigurationOption',
			args: {
				'Client.key': configuration.hashkey,
			},
		});
	}

	m.setData(update);
	m.dispatch('configuration', configuration);
}
